import { createSelector } from 'reselect';
import { getProp } from '@mews/fp';
import { TimeUnit } from '@mews/enums';
import { AppClockService, DateTimeService, DateTimeUtils } from '@mews/framework';
import { createTimeUnitRangeArray, getAppDateTimeNow } from '@mews-commander/utils';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from './enterprise';

export const getCurrentEnterpriseAppDateTimeNow = createSelector(
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    getProp<AppClockService>()('appClockService'),
    (timezone: string, appClockService) => getAppDateTimeNow({ appClockService, timezone })
);

export const getEndOfTodayUtc = createSelector(getCurrentEnterpriseAppDateTimeNow, (now) => {
    const today = DateTimeService.startOfDay(now);
    const endOfToday = DateTimeService.addDays(today, 1);
    return DateTimeService.toUtc(endOfToday).value;
});

export const getTodayStructuredDate = createSelector(getCurrentEnterpriseAppDateTimeNow, (dateTimeNow) => {
    const dateTimeToday = DateTimeService.startOfDay(dateTimeNow);
    return DateTimeUtils.dateTimeToStructuredDate(dateTimeToday);
});

export const getTimeUnitRangeArrayFromUtc = createSelector(
    getProp<{ startUtc: string; endUtc: string }>()('utcDateRange'),
    getProp<TimeUnit>()('timeUnit'),
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    ({ startUtc, endUtc }, timeUnit, timezone: string) => {
        const startDateTime = DateTimeService.fromUtcString(startUtc, timezone);
        const endDateTime = DateTimeService.fromUtcString(endUtc, timezone);
        return createTimeUnitRangeArray({ startDateTime, endDateTime, timeUnit });
    }
);

const defaultDateRange = (timeUnit: TimeUnit) => (timeUnit === TimeUnit.Hour ? 23 : 15);

export const getDefaultTimeUnitRange = createSelector(
    getProp<TimeUnit>()('timeUnit'),
    getCurrentEnterpriseAppDateTimeNow,
    (timeUnit, now) => {
        const today = DateTimeService.startOfDay(now);
        // @ts-expect-error $TSFixMeError: Argument of type 'TimeUnit' is not assignable to parameter of type 'DateTimeUnit'.
        const startDateTime = DateTimeService.startOf(timeUnit)(today);
        // @ts-expect-error $TSFixMeError: Argument of type 'TimeUnit' is not assignable to parameter of type 'DateTimePart'.
        const endDateTime = DateTimeService.add(timeUnit)(startDateTime, defaultDateRange(timeUnit));

        return {
            startDateTime,
            endDateTime,
        };
    }
);
